import { FormSelect } from '@practium/ui';
import {
	priceUnitOptions,
	type PackProduct,
	type ProductCostFormEntry,
} from '../../utils/productCosts';
import styles from './ProductCostsModal.module.css';

interface ProductCostsEditListProps {
	products: PackProduct[];
	entries: Record<string, ProductCostFormEntry>;
	errors: Record<string, string>;
	onChange: (id: string, key: keyof ProductCostFormEntry, value: string) => void;
}

export const ProductCostsEditList = ({ products, entries, errors, onChange }: ProductCostsEditListProps) => (
	<div className={styles.editList}>
		{products.map((product) => {
			const entry = entries[product.id];
			const error = errors[product.id];
			return (
				<div key={product.id} className={styles.editRow}>
					<span className={styles.name}>{product.name}</span>
					<div className={styles.editControl}>
						<div className={`${styles.priceGroup} ${error ? styles.priceGroupError : ''}`}>
							<span className={styles.currency}>R$</span>
							<input
								className={styles.priceInput}
								inputMode="decimal"
								placeholder="0,00"
								value={entry?.price ?? ''}
								onChange={(event) => onChange(product.id, 'price', event.target.value)}
								aria-label={`Preço de ${product.name}`}
							/>
							<div className={styles.unitSelect}>
								<FormSelect
									value={entry?.unit ?? ''}
									onChange={(value) => onChange(product.id, 'unit', value)}
									options={priceUnitOptions(entry?.unit ?? '')}
									triggerClassName={styles.unitTrigger}
								/>
							</div>
						</div>
						{error && <span className={styles.errorText}>{error}</span>}
					</div>
				</div>
			);
		})}
	</div>
);
